<template>
  <div class="content-width py-4" v-if="isAdmin">
    <b-button
      squared
      variant="cms_main"
      type="button"
      v-b-modal.modalVendorModal
      ><b-icon icon="plus-circle" class="mr-2"></b-icon>新增區域</b-button
    >
    <div class="pt-4">
      <b-table
        v-if="!isMobile"
        responsive
        striped
        hover
        bordered
        head-variant="light"
        :items="items"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="onFiltered"
        empty-text="目前尚無資料"
        empty-filtered-text="沒有找到符合的區域"
        show-empty
      >
        <template v-slot:head()="scope">
          <div class="text-nowrap">
            {{ scope.label }}
          </div>
        </template>
        <template v-slot:emptyfiltered="{ emptyFilteredText }">
          <div class="text-center">{{ emptyFilteredText }}</div>
        </template>
        <template v-slot:cell(zones)="data">
          {{ zoneName(data.item.zones) }}
        </template>
        <template v-slot:cell(active)="data">
          <b-dropdown
            right
            no-caret
            variant="link"
            boundary="viewport"
            class="btn-only-icon"
          >
            <template v-slot:button-content>
              <b-icon icon="three-dots-vertical" variant="dark"></b-icon>
            </template>
            <b-dropdown-item href="#" @click="edit(data.item.id)"
              ><b-icon icon="pencil-square" class="mr-2"></b-icon
              >編輯</b-dropdown-item
            >
            <b-dropdown-divider v-if="!data.item.status"></b-dropdown-divider>
            <b-dropdown-item href="#" @click="deleteZone(data.item.id)"
              ><span class="text-danger"
                ><b-icon icon="trash" class="mr-2"></b-icon>刪除</span
              ></b-dropdown-item
            >
          </b-dropdown>
        </template>
      </b-table>

      <b-table
        v-else
        striped
        bordered
        head-variant="light"
        :items="items"
        :fields="fields_mobile"
        :per-page="perPage"
        :current-page="currentPage"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="onFiltered"
        empty-text="目前尚無資料"
        empty-filtered-text="沒有找到符合的區域"
        show-empty
      >
        <template v-slot:head()="scope">
          <div class="text-nowrap">
            {{ scope.label }}
          </div>
        </template>
        <template v-slot:emptyfiltered="{ emptyFilteredText }">
          <div class="text-center">{{ emptyFilteredText }}</div>
        </template>
        <template v-slot:cell(show_details)="row">
          <div class="btn-only-icon">
            <b-button
              @click="row.toggleDetails"
              class="btn-link border-0"
              variant="outline-light"
              size="sm"
            >
              <b-icon
                :icon="row.detailsShowing ? 'chevron-down' : 'chevron-right'"
                variant="dark"
              ></b-icon>
            </b-button>
          </div>
        </template>
        <template v-slot:cell(status)="data">
          <div class="status-switch">
            <input
              type="checkbox"
              :id="'switch-' + data.index"
              v-model="data.item.status"
              @click="changeStatus('switch-' + data.index, data.item.id)"
            />
            <label :for="'switch-' + data.index"></label>
          </div>
        </template>
        <template v-slot:cell(active)="data">
          <b-dropdown
            right
            no-caret
            variant="link"
            boundary="viewport"
            class="btn-only-icon"
          >
            <template v-slot:button-content>
              <b-icon icon="three-dots-vertical" variant="dark"></b-icon>
            </template>
            <b-dropdown-item href="#" @click="edit(data.item.id)"
              ><b-icon icon="pencil-square" class="mr-2"></b-icon
              >編輯</b-dropdown-item
            >
            <b-dropdown-divider v-if="!data.item.status"></b-dropdown-divider>
            <b-dropdown-item href="#" @click="deleteZone(data.item.id)"
              ><span class="text-danger"
                ><b-icon icon="trash" class="mr-2"></b-icon>刪除</span
              ></b-dropdown-item
            >
          </b-dropdown>
        </template>
        <template v-slot:row-details="row">
          <b-card>
            <b-row class="mb-3">
              <b-col sm="3"><b>業務區域內容</b></b-col>
              <b-col> {{ zoneName(row.item.zones) }}</b-col>
            </b-row>
            <b-row class="">
              <b-col class="text-center">
                <b-button
                  size="sm"
                  squared
                  variant="cms_main"
                  @click="row.toggleDetails"
                  >收起詳細資訊</b-button
                >
              </b-col>
            </b-row>
          </b-card>
        </template>
      </b-table>

      <div class="row align-items-center" v-if="totalRows">
        <div class="col-sm col-12 text-right text-sm-left">
          顯示第 {{ currentPage == 1 ? 1 : perPage * (currentPage - 1) + 1 }} 至
          {{
            currentPage == 1
              ? totalRows > perPage
                ? perPage
                : totalRows
              : perPage * (currentPage - 1) + perPage > totalRows
              ? totalRows
              : perPage * (currentPage - 1) + perPage
          }}
          項結果，共 {{ totalRows }} 項
        </div>
        <div class="col-sm col-12">
          <b-pagination
            v-if="totalRows > perPage"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="right"
            first-number
            last-number
            class="mb-sm-0 mb-3 mt-sm-0 mt-3 cms_main"
          ></b-pagination>
        </div>
      </div>
    </div>
    <b-modal
      id="modalVendorModal"
      size="lg"
      :title="modal_title"
      footer-class="d-flex justify-content-between"
      no-close-on-backdrop
      centered
      tall
      scrollable
      @ok="onSubmit"
      @show="showModal"
      @hidden="hiddenModal"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          label="區域名稱"
          label-for="productName"
          invalid-feedback="請填寫區域名稱"
          :state="state.aliases_name"
          class="required"
        >
          <b-form-input
            id="productName"
            class="rounded-0"
            v-model="form.aliases_name"
            type="text"
            required
            placeholder="區域名稱"
            :state="state.aliases_name"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="選擇地區"
          label-for="productCategory"
          invalid-feedback="請選擇地區"
          :state="state.town_ids"
          :class="{ 'is-invalid': state.town_ids === false }"
          class="set-car-model required"
        >
          <div>
            <div class="mb-3" v-if="form.town_ids.length">
              已選擇{{ zoneTagList.length }}個區域
              <b-button
                class="ml-2"
                variant="outline-cms_main"
                size="sm"
                squared
                @click="removeTownActive('all')"
                >清除全部</b-button
              >
            </div>
            <div class="mb-3">
              <b-button
                pill
                size="sm"
                v-for="item in zoneTagList"
                :key="item.id"
                class="px-2 m-1 category-tpye"
                v-b-tooltip.hover
                title="移除此項目"
                @click="
                  item.city_id
                    ? removeTownActive(item.city_id, 'city')
                    : removeTownActive(item.town_id, 'town')
                "
              >
                {{ item.name }}
                <b-icon icon="x" aria-hidden="true"></b-icon>
              </b-button>
            </div>
            <div
              v-if="isLayoutToLg && card_active > 1"
              class="my-2"
              @click="card_active = 1"
            >
              <b-icon icon="chevron-left" variant="dark"></b-icon>
              回上一步
            </div>
            <div class="row no-gutters">
              <div
                class="col-lg-6"
                v-if="isLayoutToLg ? card_active == 1 : true"
              >
                <b-list-group class="rounded-0">
                  <template v-for="item in zoneList">
                    <b-list-group-item
                      :key="item.id"
                      class="d-flex justify-content-between align-items-center"
                      @click="clickCity(item.id, item.city_name)"
                      :active="item.id == city_active.id"
                    >
                      {{ item.city_name }}
                      <small
                        class="mr-auto text-cms_main ml-2"
                        v-if="
                          chackoutZoneActive[item.id].qty +
                            chackoutZoneActive[item.id].disabled_qty !==
                            Object.keys(chackoutZoneActive[item.id].towns)
                              .length
                        "
                      >
                        {{
                          "(還未指派地區：" +
                            (Object.keys(chackoutZoneActive[item.id].towns)
                              .length -
                              chackoutZoneActive[item.id].qty -
                              chackoutZoneActive[item.id].disabled_qty) +
                            "個)"
                        }}
                      </small>
                      <b-badge
                        v-if="chackoutZoneActive[item.id].qty"
                        variant="cms_main"
                        pill
                        class="ml-auto mr-2"
                        >{{ chackoutZoneActive[item.id].qty }}</b-badge
                      >
                      <b-icon-chevron-right></b-icon-chevron-right>
                    </b-list-group-item>
                  </template>
                </b-list-group>
              </div>
              <div
                class="col-lg-6 accordion"
                v-if="isLayoutToLg ? card_active > 1 : true"
              >
                <b-card-group>
                  <b-card
                    no-body
                    header-tag="header"
                    class="rounded-0"
                    header-class="rounded-0"
                  >
                    <template #header v-if="city_active.name">
                      <b-form-checkbox
                        :id="'brand_' + city_active.id"
                        v-model="chackoutZoneActive[city_active.id].active"
                        @change="checkedCityActive(city_active.id)"
                        :disabled="chackoutZoneActive[city_active.id].disabled"
                      >
                        {{ city_active.name }}
                      </b-form-checkbox>
                    </template>
                    <b-list-group class="model_list">
                      <template v-for="item in getTownlList">
                        <b-list-group-item :key="item.id" class=" rounded-0">
                          <div
                            class="d-flex justify-content-between align-items-center"
                          >
                            <b-form-checkbox
                              :id="'town' + item.id"
                              :disabled="
                                chackoutZoneActive[city_active.id].towns[
                                  item.id
                                ].disabled
                              "
                              v-model="
                                chackoutZoneActive[city_active.id].towns[
                                  item.id
                                ].active
                              "
                              @change="
                                checkedTownActive(item.zone_city_id, item.id)
                              "
                            >
                              {{ item.town_name }}
                            </b-form-checkbox>
                          </div>
                        </b-list-group-item>
                      </template>
                    </b-list-group>
                  </b-card>
                </b-card-group>
              </div>
            </div>
          </div>
        </b-form-group>
      </form>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button squared variant="outline-dark" type="button" @click="cancel()"
          >取消</b-button
        >
        <b-button squared variant="cms_main" type="submit" @click="ok()"
          >儲存</b-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
import { Swal, Toast } from "@/plugins/sweetalert2.js";
import { Zone } from "@/assets/api/cms.js";
import { getZone } from "@/assets/api.config.js";

export default {
  name: "Zone",
  props: ["search", "isMobile", "token", "isAdmin"],
  data() {
    return {
      isLayoutToLg: false,
      currentPage: 1,
      edit_id: null,
      card_active: 1,
      city_active: {
        id: null,
        name: null
      },
      fields: [
        {
          key: "aliases_name",
          label: "業務區域名稱",
          tdClass: "align-middle",
          sortable: true
        },
        {
          key: "zones",
          label: "業務區域內容",
          tdClass: "align-middle"
        },
        {
          key: "active",
          label: "",
          tdClass: "align-middle",
          thStyle: "width:35px"
        }
      ],
      fields_mobile: [
        {
          key: "show_details",
          label: "",
          tdClass: "align-middle",
          thStyle: "width:35px"
        },
        {
          key: "aliases_name",
          label: "業務區域名稱",
          tdClass: "align-middle",
          sortable: true
        },
        {
          key: "active",
          label: "",
          tdClass: "align-middle",
          thStyle: "width:35px"
        }
      ],
      filter: null,
      filterOn: ["aliases_name"],
      form: {
        aliases_name: "",
        town_ids: []
      },
      isEdit: false,
      isModalShow: false,
      items: null,
      modal_title: "新增業務區域",
      perPage: 10,
      state: {
        aliases_name: null,
        town_ids: null
      },
      totalRows: null,
      zoneList: [],
      chackoutZone: {},
      chackoutZoneActive: {}
    };
  },
  computed: {
    getTownlList() {
      if (!this.city_active.id) return;
      let list;
      this.zoneList.forEach(val => {
        if (val.id === this.city_active.id) {
          list = val.towns;
        }
      });
      return list;
    },
    zoneTagList() {
      if (!this.form.town_ids.length) return;
      let zoneTagList = [];
      let hasCityList = {};
      this.form.town_ids.forEach(town_id => {
        Object.keys(this.chackoutZoneActive).forEach(val => {
          Object.keys(this.chackoutZoneActive[val].towns).forEach(town => {
            if (town == town_id) {
              if (
                this.chackoutZoneActive[val].qty ==
                Object.keys(this.chackoutZoneActive[val].towns).length
              ) {
                if (hasCityList[val]) return;
                zoneTagList.push({
                  city_id: val,
                  name: this.chackoutZoneActive[val].city_name
                });
                hasCityList[val] = [];
              } else {
                zoneTagList.push({
                  town_id: town,
                  name:
                    this.chackoutZoneActive[val].city_name +
                    this.chackoutZoneActive[val].towns[town].name
                });
              }
            }
          });
        });
      });
      return zoneTagList;
    }
  },
  created() {
    // if (!this.isAdmin) {
    //   this.$router.push({ name: "訂單管理" });
    //   return;
    // }
    this.perPage = process.env.VUE_APP_TABLE_ROW_LENGTH || 15;
    this.filter = this.search;
    this.getZoneData();
    getZone()
      .then(res => {
        if (res.status <= 201) {
          this.zoneList = res.data;
          this.zoneKeyMap();
        } else {
          Toast.fire({
            icon: "error",
            title: "地區資料讀取失敗",
            text: res.data.error
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
  },
  watch: {
    form: {
      handler: function() {
        if (this.isModalShow && this.isEdit) {
          this.checkFormState();
        }
      },
      deep: true
    },
    chackoutZone: {
      handler: function() {
        this.checkedQty();
      },
      deep: true
    },
    iten() {
      this.zoneDisabled();
    }
  },
  methods: {
    getZoneData() {
      Zone.get("", this.token)
        .then(res => {
          if (res.status <= 201) {
            this.items = res.data;
            this.totalRows = this.items.length;
          } else {
            Toast.fire({
              icon: "error",
              title: "業務區域資料讀取失敗",
              text: res.data.error
            });
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    deleteZone(id) {
      Swal.fire({
        title: "刪除",
        text: "確定要刪除此區域嗎？",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "取消",
        confirmButtonText: "刪除"
      }).then(result => {
        if (result.value) {
          Zone.delete(id, this.token)
            .then(res => {
              if (res.status <= 201) {
                Toast.fire({
                  icon: "success",
                  title: "刪除成功"
                });
                this.getZoneData();
              } else {
                Toast.fire({
                  icon: "error",
                  title: "刪除失敗",
                  text: res.data.error
                });
              }
            })
            .catch(error => {
              console.error(error);
            });
        }
      });
    },
    zoneKeyMap() {
      let obj = {};
      let objActive = {};
      this.zoneList.forEach(val => {
        obj[val.id] = [];

        objActive[val.id] = {};
        objActive[val.id].city_name = val.city_name;
        objActive[val.id].qty = null;
        objActive[val.id].disabled_qty = null;
        objActive[val.id].active = false;
        objActive[val.id].disabled = false;
        objActive[val.id].towns = {};

        val.towns.forEach(town => {
          objActive[val.id].towns[town.id] = {};
          objActive[val.id].towns[town.id].name = town.town_name;
          objActive[val.id].towns[town.id].active = false;
          objActive[val.id].towns[town.id].disabled = false;
        });
      });
      this.chackoutZone = Object.assign({}, this.chackoutZone, obj);
      this.chackoutZoneActive = Object.assign(
        {},
        this.chackoutZoneActive,
        objActive
      );
    },
    zoneDisabled() {
      this.items.forEach(val => {
        val.zones.forEach(zone => {
          this.chackoutZoneActive[zone.city_id].towns[
            zone.town_id
          ].active = true;
          this.chackoutZoneActive[zone.city_id].towns[
            zone.town_id
          ].disabled = true;
          this.checkedTownActive(zone.city_id, zone.town_id);
          this.$nextTick(function() {
            this.chackoutZoneActive[zone.city_id].disabled =
              this.chackoutZone[zone.city_id].length ==
              Object.keys(this.chackoutZoneActive[zone.city_id].towns).length
                ? true
                : false;
          });
        });
      });
    },
    zoneNameMap(data) {
      let zone = {};
      let zoneQty = {};
      data.forEach(iten => {
        this.zoneList.forEach(zoneList => {
          if (iten.city_id == zoneList.id) {
            if (!zone[zoneList.city_name]) {
              zone[zoneList.city_name] = [];
              zoneQty[zoneList.city_name] = zoneList.towns.length;
            }
            zone[zoneList.city_name].push(iten.town_name);
          }
        });
      });
      return {
        zone,
        zoneQty
      };
    },
    zoneName(data) {
      let zoneText = "";
      let zone = this.zoneNameMap(data).zone;
      let zoneQty = this.zoneNameMap(data).zoneQty;

      Object.keys(zone).forEach((item, index) => {
        if (index) {
          zoneText += "、";
        }
        zoneText += item;
        if (zone[item].length == zoneQty[item]) return;
        zoneText += "(";
        zone[item].forEach((value, index) => {
          if (index) {
            zoneText += "、";
          }
          zoneText += value;
        });
        zoneText += ")";
      });
      return zoneText;
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    resetForm() {
      this.modal_title = "新增業務區域";
      this.isEdit = false;
      this.edit_id = null;

      this.state.aliases_name = null;
      this.state.town_ids = null;

      this.form.aliases_name = "";
      this.form.town_ids = [];
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.checkFormState();
      return valid;
    },
    checkFormState() {
      this.form.aliases_name
        ? (this.state.aliases_name = null)
        : (this.state.aliases_name = false);
      this.form.town_ids.length
        ? (this.state.town_ids = null)
        : (this.state.town_ids = false);
    },
    clickCity(id, name) {
      this.city_active.id = id;
      this.city_active.name = name;
      this.card_active = 2;
    },
    checkedCityActive(city_active) {
      this.$nextTick(function() {
        this.chackoutZone[city_active] = [];
        Object.keys(this.chackoutZoneActive[city_active].towns).forEach(key => {
          if (this.chackoutZoneActive[city_active].towns[key].disabled) return;
          if (this.chackoutZoneActive[city_active].active) {
            this.chackoutZoneActive[city_active].towns[key].active = true;
            this.chackoutZone[city_active].push(key);
          } else {
            this.chackoutZoneActive[city_active].towns[key].active = false;
          }
        });
      });
    },
    checkedTownActive(city_id, town_id) {
      this.$nextTick(function() {
        if (this.chackoutZoneActive[city_id].towns[town_id].active) {
          let hasActive = false;
          this.chackoutZone[city_id].forEach(val => {
            if (val == town_id) {
              hasActive = true;
            }
          });
          if (hasActive) return;
          this.chackoutZone[city_id].push(town_id);
          this.chackoutZoneActive[city_id].active =
            this.chackoutZone[city_id].length ==
            Object.keys(this.chackoutZoneActive[city_id].towns).length
              ? true
              : false;
        } else {
          this.chackoutZoneActive[city_id].active = false;
          this.chackoutZone[city_id].forEach((val, index) => {
            if (val == town_id) {
              this.chackoutZone[city_id].splice(index, 1);
            }
          });
        }
      });
    },
    checkedQty() {
      this.$nextTick(function() {
        let towns_id = [];
        Object.keys(this.chackoutZoneActive).forEach(city_id => {
          let qty = 0;
          if (this.chackoutZoneActive[city_id].disabled) return;
          Object.keys(this.chackoutZoneActive[city_id].towns).forEach(
            town_id => {
              if (
                this.chackoutZoneActive[city_id].towns[town_id].active &&
                !this.chackoutZoneActive[city_id].towns[town_id].disabled
              ) {
                qty++;
                towns_id.push(town_id);
              }
            }
          );
          this.chackoutZoneActive[city_id].qty = qty;
        });
        this.form.town_ids = towns_id;
      });
      this.disabledQty();
    },
    disabledQty() {
      this.$nextTick(function() {
        Object.keys(this.chackoutZoneActive).forEach(city_id => {
          let qty = 0;
          Object.keys(this.chackoutZoneActive[city_id].towns).forEach(
            town_id => {
              if (
                this.chackoutZoneActive[city_id].towns[town_id].active &&
                this.chackoutZoneActive[city_id].towns[town_id].disabled
              ) {
                qty++;
              }
            }
          );
          this.chackoutZoneActive[city_id].disabled_qty = qty;
        });
      });
    },
    edit(id) {
      this.resetForm();
      this.isEdit = true;
      this.edit_id = id;
      this.$root.$emit("bv::show::modal", "modalVendorModal", "#btnShow");
    },
    removeTownActive(id, type) {
      if (id == "all") {
        this.city_active.id = null;
        this.city_active.name = null;
        this.card_active = 1;
        this.zoneKeyMap();
        this.zoneDisabled();
        if (this.isEdit) {
          this.form.town_ids.forEach(town_id => {
            Object.keys(this.chackoutZoneActive).forEach(val => {
              Object.keys(this.chackoutZoneActive[val].towns).forEach(town => {
                if (town == town_id) {
                  this.chackoutZoneActive[val].disabled = false;
                  this.chackoutZoneActive[val].towns[town].disabled = false;
                  this.chackoutZoneActive[val].towns[town].active = false;
                  this.checkedTownActive(val, town);
                }
              });
            });
          });
        }
      } else {
        if (type == "city") {
          this.chackoutZoneActive[id].active = false;
          this.checkedCityActive(id);
        } else {
          Object.keys(this.chackoutZoneActive).forEach(val => {
            Object.keys(this.chackoutZoneActive[val].towns).forEach(town => {
              if (town == id) {
                this.chackoutZoneActive[val].towns[town].active = false;
                this.checkedTownActive(val, town);
              }
            });
          });
        }
      }
    },
    showModal() {
      this.isModalShow = true;
      this.removeTownActive("all");
      if (this.isEdit) {
        this.modal_title = "編輯業務區域";
        Zone.get(this.edit_id, this.token)
          .then(res => {
            if (res.status <= 201) {
              this.form.aliases_name = res.data.aliases_name;
              this.form.town_ids = res.data.zones;
              this.$nextTick(function() {
                res.data.zones.forEach(zone => {
                  Object.keys(this.chackoutZoneActive).forEach(val => {
                    Object.keys(this.chackoutZoneActive[val].towns).forEach(
                      town => {
                        if (town == zone.id) {
                          this.chackoutZoneActive[val].disabled = false;
                          this.chackoutZoneActive[val].towns[
                            town
                          ].disabled = false;
                          this.checkedTownActive(val, town);
                        }
                      }
                    );
                  });
                });
                this.checkedQty();
              });
            } else {
              Toast.fire({
                icon: "error",
                title: "業務區域資料讀取失敗",
                text: res.data.error
              });
            }
          })
          .catch(err => {
            console.error(err);
          });
      } else {
        this.resetForm();
      }
    },
    hiddenModal() {
      this.isModalShow = false;
      this.resetForm();
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.handleSubmit();
    },
    handleSubmit() {
      if (!this.checkFormValidity()) {
        return;
      }
      for (const value of Object.keys(this.state)) {
        if (this.state[value] === false) {
          return;
        }
      }
      let newData = Object.assign({}, this.form);
      if (this.isEdit) {
        Zone.update(this.edit_id, newData, this.token)
          .then(res => {
            if (res.status <= 201) {
              Toast.fire({
                icon: "success",
                title: "編輯成功"
              });
              this.$root.$emit(
                "bv::hide::modal",
                "modalVendorModal",
                "#btnShow"
              );
              this.getZoneData();
            } else {
              Toast.fire({
                icon: "error",
                title: "編輯失敗",
                text: res.data.error
              });
            }
          })
          .catch(err => {
            console.error(err);
          });
      } else {
        Zone.create(newData, this.token)
          .then(res => {
            if (res.status <= 201) {
              Toast.fire({
                icon: "success",
                title: "新增成功"
              });
              this.$root.$emit(
                "bv::hide::modal",
                "modalVendorModal",
                "#btnShow"
              );
              this.getZoneData();
            } else {
              Toast.fire({
                icon: "error",
                title: "新增失敗",
                text: res.data.error
              });
            }
          })
          .catch(err => {
            console.error(err);
          });
      }
    },
    reportWindowSize() {
      const windowWidth = window.innerWidth;
      if (windowWidth < 992) {
        this.isLayoutToLg = true;
      } else {
        this.isLayoutToLg = false;
      }
    }
  },
  mounted() {
    this.reportWindowSize();
    window.addEventListener("resize", this.reportWindowSize);
  }
};
</script>
